import { setTerms } from './helpers';

export const setBuildingHeatingTypes = setTerms('building_heating_type');
